module.exports = __webpack_public_path__ + "img/View_Icon_White.0262d443.svg";